import { Code, ConnectError } from '@connectrpc/connect'
import type { Interceptor } from '@connectrpc/connect'

/* Global side effect for expired sessions: the router registers a handler at
   bootstrap (clear session, redirect to login). The original ConnectError is
   rethrown - normalization to AppError happens at the call site via
   fromConnectError/useRpc, so connect's error contract stays intact. */
let onSessionExpired: (() => void) | null = null

export function registerSessionExpiredHandler(handler: () => void): void {
  onSessionExpired = handler
}

export const errorInterceptor: Interceptor = (next) => async (req) => {
  try {
    return await next(req)
  } catch (err) {
    if (err instanceof ConnectError && err.code === Code.Unauthenticated) {
      onSessionExpired?.()
    }
    throw err
  }
}
